<div *ngIf="editExam">
    <app-exam-handler></app-exam-handler>
</div>
<div *ngIf="editPatient">
    <app-patient-handler></app-patient-handler>
</div>
